import type { ComponentType } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

// Permissive icon type — accepts lucide-react's ForwardRefExoticComponent.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
type IconLike = ComponentType<any>;

type Props = {
  title: string;
  description: string;
  count: number | null;
  countLabel: string;
  icon: IconLike;
  to: string;
  accent: "library" | "initiative" | "platform";
  loading?: boolean;
};

export function PillarTile({
  title,
  description,
  count,
  countLabel,
  icon: Icon,
  to,
  accent,
  loading,
}: Props) {
  return (
    <Link to={to} className={`pillar-tile pillar-${accent}`}>
      <div className="pillar-tile-head">
        <div className="pillar-tile-icon" aria-hidden>
          <Icon size={22} strokeWidth={1.75} />
        </div>
        <div className="pillar-tile-count">
          {loading ? <span className="kpi-skeleton" /> : count ?? "–"}
          <span className="pillar-tile-count-label">{countLabel}</span>
        </div>
      </div>
      <div className="pillar-tile-body">
        <div className="pillar-tile-title">{title}</div>
        <div className="pillar-tile-desc">{description}</div>
      </div>
      <div className="pillar-tile-foot">
        Open <ArrowRight size={14} />
      </div>
    </Link>
  );
}
